import React, { createContext, useContext, useState } from "react";

interface UploadModalContextType {
  showUploadMobileModal: boolean;
  openUploadMobileModal: () => void;
  closeUploadMobileModal: () => void;
  
  showGuidelineMobileModal: boolean;
  openGuidelineMobileModal: () => void;
  closeGuidelineMobileModal: () => void;
}

const UploadModalContext = createContext<UploadModalContextType | undefined>(undefined);

export const UploadModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showUploadMobileModal, setShowUploadMobileModal] = useState(false);

  const openUploadMobileModal = () => setShowUploadMobileModal(true);
  const closeUploadMobileModal = () => setShowUploadMobileModal(false);

  const [showGuidelineMobileModal, setShowGuidelineMobileModal] = useState(false);

  const openGuidelineMobileModal = () => setShowGuidelineMobileModal(true);
  const closeGuidelineMobileModal = () => setShowGuidelineMobileModal(false);

  return (
    <UploadModalContext.Provider value={{ 
        showUploadMobileModal, openUploadMobileModal, closeUploadMobileModal,
        showGuidelineMobileModal, openGuidelineMobileModal, closeGuidelineMobileModal 
        }}>
      {children}
    </UploadModalContext.Provider>
  );
};

export const useUploadModal = () => {
  const context = useContext(UploadModalContext);
  if (!context) throw new Error("useUploadModal must be used within UploadModalProvider");
  return context;
};
